import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_productPropertyList": "/product/property/queryList", // 根据类目Code查询属性
}

// initial state
const state = {
    productPropertyList: [],
}

// getters
const getters = {
    getProductPropertyList: state => {
        return state.productPropertyList
    },
}

// actions
const actions = {
    getProductPropertyList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_productPropertyList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('PRODUCT_PROPERTY_LIST', res.data || {});
            } else {
                commit('PRODUCT_PROPERTY_LIST', {});
            }
        }).catch(err => {
            commit('PRODUCT_PROPERTY_LIST', {});
        })
    },
}


// mutations
const mutations = {
    PRODUCT_PROPERTY_LIST: (state, pageData) => {
        state.productPropertyList = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/property.js